import { AiOutlineClose } from "react-icons/ai";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { pollQuestions } from "../../../../static/pollQuestions";
import { GraphContainer } from "./style";

const GraphScreen = ({ showNextPoll, closePoll, currentPoll }) => {
  const data = [
    { option: "a", percentage: 30 },
    { option: "b", percentage: 20 },
    { option: "c", percentage: 40 },
    { option: "d", percentage: 10 },
  ].sort((a, b) => a - b);

  return (
    <GraphContainer className="h-full w-full">
      <div className="absolute right-0 top-0">
        <AiOutlineClose className="h-6 w-6 cursor-pointer bg-red-500 text-white  p-1" onClick={() => closePoll()} />
      </div>

      <div className="h-52">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="option" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="percentage" fill="#8884d8" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {currentPoll < pollQuestions.length - 1 && (
        <div className="mt-4 mx-auto text-center">
          <button className="text-xs text-white px-6 py-2 rounded-full bg-main" onClick={showNextPoll}>
            Take another Poll
          </button>
        </div>
      )}
    </GraphContainer>
  );
};

export default GraphScreen;
